import React from 'react'

import { Grid, IconButton, Icon } from '@mui/material'

const ButtonComponent = ({ rowId, approve, approveDisabled, refuse, refuseDisabled, ...props }) => <>
  <Grid container spacing={1}>
    <Grid size="grow">
      <IconButton onClick={refuse} color={'error'} disabled={refuseDisabled}>
        <Icon >close</Icon>
      </IconButton>
    </Grid>
    <Grid size="grow">
      <IconButton onClick={approve} color={'success'} disabled={approveDisabled}>
        <Icon >check</Icon>
      </IconButton>
    </Grid>
  </Grid>
</>

export default React.memo(ButtonComponent)
